"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpModal = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
require("./styles.scss");
const modal_html_1 = __importDefault(require("./modal.html"));
let ItpModal = class ItpModal extends vue_1.default {
    activeElement;
    $refs;
    header;
    noHeader;
    noFooter;
    emptyFooter;
    noHeaderTitle;
    noHeaderClose;
    compact;
    noCloseButton;
    noPrimaryButton;
    noBackdrop;
    noShow;
    closeButtonText;
    primaryButtonText;
    submitButtonText;
    headerClass;
    contentClass;
    footerClass;
    size;
    form;
    data() {
        return {
            modalDialogClass: {
                'compact': this.compact,
                'modal-xl': this.size === 'xl',
                'modal-lg': this.size === 'lg',
                'modal-sm': this.size === 'sm',
                'modal-full-screen': this.size === 'full-screen'
            },
            contentProps: {
                tag: this.form ? 'form' : 'div',
                name: this.form ? 'form' : null
            }
        };
    }
    get showFooter() {
        return !this.noFooter && !this.compact;
    }
    get showPrimaryButton() {
        return !this.form && !this.noPrimaryButton && !this.emptyFooter && !this.compact;
    }
    get showSubmitButton() {
        return this.form && !this.noPrimaryButton && !this.emptyFooter && !this.compact;
    }
    get showCloseButton() {
        return !this.emptyFooter && !this.noCloseButton && !this.compact;
    }
    beforeMount() {
        this.activeElement = document.activeElement;
        window.addEventListener('keyup', this.onKeyUp);
    }
    beforeDestroy() {
        window.removeEventListener('keyup', this.onKeyUp);
        if (this.activeElement instanceof HTMLElement) {
            this.activeElement.focus();
        }
        this.activeElement = null;
    }
    beginClose($event, result) {
        if (this.canClose()) {
            this.$emit('close', result);
        }
    }
    beginSubmit($event) {
        if (this.observer) {
            return this.observer.handleSubmit(() => this.$emit('submit'));
        }
        this.$emit('submit');
    }
    beginCommit($event) {
        this.$emit('commit');
    }
    onKeyUp(event) {
        if (event.which === 27) {
            event.stopPropagation();
            this.beginClose(event, { cancel: true });
        }
    }
    canClose() {
        if (this.form && this.observer && this.observer.flags.dirty) {
            return confirm('You have changes, bro! Dou you want to close this dialog?');
        }
        return true;
    }
    get observer() {
        return this.$refs.observer;
    }
};
exports.ItpModal = ItpModal;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpModal.prototype, "header", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noFooter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "emptyFooter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noHeaderTitle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noHeaderClose", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "compact", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noCloseButton", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noPrimaryButton", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noBackdrop", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpModal.prototype, "noShow", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'Close' }),
    __metadata("design:type", String)
], ItpModal.prototype, "closeButtonText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'Ok' }),
    __metadata("design:type", String)
], ItpModal.prototype, "primaryButtonText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'Submit' }),
    __metadata("design:type", String)
], ItpModal.prototype, "submitButtonText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpModal.prototype, "headerClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpModal.prototype, "contentClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpModal.prototype, "footerClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Object)
], ItpModal.prototype, "form", void 0);
exports.ItpModal = ItpModal = __decorate([
    (0, vue_property_decorator_1.Component)({ template: modal_html_1.default })
], ItpModal);
//# sourceMappingURL=modal.js.map